var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLastmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 52,
    viewBox: "0 0 80 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 37.8418H2.95271V43.1526H8.39677V37.8418H11.3495V51.2623H8.39677V45.8797H2.95271V51.2623H0V37.8418Z",
    fill: "#1B303A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5381 37.8418H24.6573V40.4664H17.4703V43.1936H23.7961V45.8182H17.4703V48.6376H24.7598V51.2623H14.5381V37.8418Z",
    fill: "#1B303A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1809 45.6442L34.397 41.2869L32.613 45.6442H36.1809ZM33.0744 37.7498H35.8015L41.5532 51.2625H38.4672L37.2369 48.2483H31.557L30.3267 51.2625H27.3125L33.0744 37.7498Z",
    fill: "#1B303A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6506 37.8418H71.6034V43.1526H77.0474V37.8418H80.0001V51.2623H77.0474V45.8797H71.6034V51.2623H68.6506V37.8418Z",
    fill: "#1B303A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.147 37.8418H47.0997V48.5761H53.7945V51.2623H44.147V37.8418Z",
    fill: "#52B0C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6339 40.569H54.5432V37.8418H65.6671V40.569H61.5867V51.2623H58.6339V40.569",
    fill: "#1B303A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.593 1.82495L12.5488 13.6665H15.5938L18.9566 5.29028L17.593 1.82495Z",
    fill: "#52B0C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0279 0.143555H18.3008L21.5816 8.34553H19.1517L18.229 10.6728H22.5145L23.7141 13.6666H26.7591L21.0279 0.143555Z",
    fill: "#52B0C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.194824H2.95271V10.9292H9.63732V13.6153H0V0.194824Z",
    fill: "#1B303A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0895 2.92198H43.009V0.194824H54.133V2.92198H50.0525V13.6153H47.0998V2.92198",
    fill: "#1B303A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3733 11.6571L31.1162 9.56555C32.326 10.56 33.5871 11.1957 35.1249 11.1957C36.3347 11.1957 37.0626 10.7138 37.0626 9.93464V9.89363C37.0626 9.1452 36.6013 8.76586 34.356 8.19172C31.6493 7.50481 29.9064 6.75638 29.9064 4.09073V4.04972C29.9064 1.61989 31.8646 0 34.602 0C36.5603 0 38.2212 0.615148 39.5847 1.70191L38.0469 3.9267C36.8576 3.1065 35.6888 2.60413 34.561 2.60413C33.4333 2.60413 32.8386 3.127 32.8386 3.77291V3.81392C32.8386 4.69563 33.4128 4.9827 35.7298 5.57734C38.457 6.28476 39.9846 7.269 39.9846 9.60656V9.64757C39.9846 12.3132 37.9546 13.8101 35.0532 13.8101C33.0334 13.8101 30.9829 13.0924 29.3733 11.6571Z",
    fill: "#1B303A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.9158H3.17826L6.70511 24.5854L10.232 18.9158H13.4102V32.3363H10.478V23.5704L6.70511 29.3015H6.63335L2.8912 23.6217V32.3363H0V18.9158Z",
    fill: "#1B303A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0901 18.9158H22.0428V32.3363H19.0901V18.9158Z",
    fill: "#1B303A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0098 18.9158H30.9625V29.6501H37.6573V32.3363H28.0098V18.9158",
    fill: "#52B0C6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1272 18.9158H52.2464V21.5404H45.0594V24.2676H51.3852V26.8922H45.0594V29.7116H52.3489V32.3363H42.1272V18.9158",
    fill: "#1B303A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLastmile);
export default __webpack_public_path__ + "static/media/logo-lastmile.aa51b1ea6b0df3b27dd944e38318ad47.svg";
export { ForwardRef as ReactComponent };